import * as actions from './actions'
import { ActionType, getType } from 'typesafe-actions'

interface FormState {
  emailAddress: string
  firstName: string
  lastName: string
  confirmedTerms: boolean
}

export function reducer(
  state: FormState = {
    emailAddress: '',
    firstName: '',
    lastName: '',
    confirmedTerms: false
  },
  action: ActionType<typeof actions>
) {
  switch (action.type) {
    case getType(actions.setEMailAddress):
      return {
        ...state,
        emailAddress: action.payload
      }

    case getType(actions.setFirstName):
      return {
        ...state,
        firstName: action.payload
      }

    case getType(actions.setLastName):
      return {
        ...state,
        lastName: action.payload
      }

    case getType(actions.toggleTerms):
      return {
        ...state,
        confirmedTerms: !state.confirmedTerms
      }
  }

  return state
}
